export * from './fonds.component';
export * from './fonds.component.module';